// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconCallOutMini: React.FC<{}> = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="543"
            height="121"
            viewBox="0 0 543 121"
        >
            <defs>
                <pattern id="b" width="100%" height="100%" x="0%" patternUnits="objectBoundingBox">
                    <use xlinkHref="#a" transform="scale(1.66667)" />
                </pattern>
                <image
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAAAs0lEQVRoBe2YQQrDMAwE4/7J/3+AH9XS4x7FkG0Dk5vAkuIZC4zX3vt9Db5zzhosv+6u/5r8zD+udQO/tqIBDUACHiEIEKdrACOEBR5vYHSv+cK6+24zrf94A24AziBO1wBGCAtoAALE6RrACGEBDUCAOH1N7x6+C2HmWcAZSB79SAN95tlRA8mjH2mgzzw7aiB59CPfhfrMs6MzkDz6kQb6zLOjBpJHP9JAn3l21EDy6EcfG0kbmWsMNT0AAAAASUVORK5CYII="
                    id="a"
                    width="48"
                    height="48"
                />
            </defs>
            <g fill="none" transform="translate(1 1)">
                <path
                    fill="#F6F6F0"
                    fillRule="evenodd"
                    stroke="#989A87"
                    d="M541.5,4 L541.5,115 C541.5,117.485281 539.485281,119.5 537,119.5 L4,119.5 C1.51471863,119.5 -0.5,117.485281 -0.5,115 L-0.5,4 C-0.5,1.6858919 1.25464608,-0.244648259 3.56580734,-0.478711733 L4.00000017,-0.499999741 L537,-0.5 C539.485281,-0.5 541.5,1.51471863 541.5,4 Z"
                />
                <g transform="translate(104 12)">
                    <text fill="#3B3B3B" fontFamily="Adelle-Regular, Adelle" fontSize="14">
                        <tspan x="0" y="43">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut{" "}
                        </tspan>
                        <tspan x="0" y="65">
                            ultricies dolor nunc, nec interdum risus ultrices vitae. Morbi non{" "}
                        </tspan>
                        <tspan x="0" y="87">
                            lacinia sem.
                        </tspan>
                    </text>
                    <text fill="#0C0908" fontFamily="TVNordEF-BlackCon" fontSize="18">
                        <tspan x="0" y="16">
                            {"{H5 : Headline Title}"}
                        </tspan>
                    </text>
                </g>
                <rect width="80" height="80" fill="url(#b)" fillRule="evenodd" transform="translate(12 12)" />
            </g>
        </svg>
    );
};

export default React.memo(IconCallOutMini);
